<svg width="46" height="46" viewBox="0 0 46 46" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_4583_4593)">
<path d="M23 46C35.7025 46 46 35.7025 46 23C46 10.2975 35.7025 0 23 0C10.2975 0 0 10.2975 0 23C0 35.7025 10.2975 46 23 46Z" fill="#BB3949"/>
<path d="M25.654 12.8268C25.654 11.6054 24.6639 10.6152 23.4425 10.6152C22.2211 10.6152 21.231 11.6054 21.231 12.8268V26.096C21.231 27.3174 22.2211 28.3075 23.4425 28.3075C24.6639 28.3075 25.654 27.3174 25.654 26.096V12.8268Z" fill="white"/>
<path d="M25.654 32.2887C25.654 31.0673 24.6639 30.0771 23.4425 30.0771C22.2211 30.0771 21.231 31.0673 21.231 32.2887C21.231 33.5101 22.2211 34.5002 23.4425 34.5002C24.6639 34.5002 25.654 33.5101 25.654 32.2887Z" fill="white"/>
</g>
<defs>
<clipPath id="clip0_4583_4593">
<rect width="46" height="46" fill="white"/>
</clipPath>
</defs>
</svg>
